import { onSubmitMultiplier } from 'utils';
import { MultiplierRegisterOnSubmitFunction } from './createMultiplier.type';

const multiplierRegisterOnSubmit: MultiplierRegisterOnSubmitFunction = payload => {
  return onSubmitMultiplier({ method: 'post', ...payload });
};

export default multiplierRegisterOnSubmit;
